/**
 * 指定文字数より多い場合、省略して三点リーダで返す
 * @param text 文字列
 * @param len 指定文字数
 * @returns 三点リーダで省略された文字列
 */
export function textAjust(text: string, len = 50) {
  if (text && text.length > len) {
    return `${text.substring(0, len - 3)}...`;
  }
  return text;
}

/**
 * <br>を半角スペースに変換し、最大文字数以下で切り出された文字列を返す
 * @param {string} str - 対象文字列
 * @param {number} limit - 最大文字数
 * @returns {string} 最大文字数以下で切り出された文字列
 */
export const subStringNoBreak = (str: string, limit: number): string => {
  const replaceStr = str.replace(/\r?\n/g, ' '); // 改行コードを半角スペースに変換

  if (replaceStr.length <= limit) return replaceStr; // 上限以下の場合はそのまま返す
  return replaceStr.substring(0, limit);
};

/**
 * 結合した文字列を返却する
 * @param {string} delimiter 区切り文字
 * @param {(string | null | undefinded)[]} textArray テキスト
 * @returns {string} 結合したテキスト
 */
export const joinText = (
  delimiter: string,
  ...textArray: (string | null | undefined)[]
): string => {
  let result = '';

  textArray.forEach((str) => {
    if (str) {
      result = result + delimiter + str;
    }
  });

  // 先頭の区切り文字削除
  result = result.substring(delimiter.length);

  return result;
};

/**
 * 改行コードが取り除かれた文字列を返す
 * @param {string | null} str 対象文字列
 * @returns {string} 改行コードが取り除かれた文字列
 */
export const removeLF = (str: string | null): string => {
  if (str === null) str = '';
  const result = str.replace(/\r\n|\n/g, '');
  return result;
};
